
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"57","viewBox":"0 0 56 57","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.0001 51.6892H35.0001C46.6667 51.6892 51.3334 47.0226 51.3334 35.3559V21.3559C51.3334 9.68925 46.6667 5.02258 35.0001 5.02258H21.0001C9.33341 5.02258 4.66675 9.68925 4.66675 21.3559V35.3559C4.66675 47.0226 9.33341 51.6892 21.0001 51.6892Z","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.3333 19.606C18.6666 21.9393 22.4699 21.9393 24.8266 19.606","stroke":"currentColor","stroke-width":"3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.1733 19.606C33.5067 21.9393 37.31 21.9393 39.6667 19.606","stroke":"currentColor","stroke-width":"3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.6 30.6893H36.4C37.5667 30.6893 38.5 31.6227 38.5 32.7893C38.5 38.5993 33.81 43.2893 28 43.2893C22.19 43.2893 17.5 38.5993 17.5 32.7893C17.5 31.6227 18.4333 30.6893 19.6 30.6893Z","stroke":"currentColor","stroke-width":"3","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    